export default __webpack_public_path__ + "static/media/grid-dynamic.aa411fd0.svg";